<template>
  <div class="fields">
    <template v-for="row in rows">
      <template v-for="(field, key) in row">
        <field
          :field="field"
          :key="
            field.id && configTemplate
              ? getFieldId({
                  id: field.id,
                  category: field.category || category,
                })
              : key
          "
          v-if="
            field.type !== 'contentGroup' &&
            field.type !== 'content' &&
            field.type !== 'custom' &&
            !isContentType({
              id: field.id,
              category: field.category || category,
            }) &&
            !isObjectType({
              id: field.id,
              category: field.category || category,
            })
          "
          :bulkDelete="bulkDelete"
          :parentField="parentField"
          :category="field.category || category"
        />
        <customFields
          v-if="field.type === 'custom'"
          :id="field.id"
          :bulkDelete="bulkDelete"
          :category="field.category || category"
          :field="field.field"
          :key="
            field.id && configTemplate
              ? getFieldId({
                  id: field.id,
                  category: field.category || category,
                })
              : key
          "
        />
        <template v-if="field.type === 'contentGroup'">
          <template v-for="field in field.items">
            <field
              v-if="
                field.type === 'config' &&
                !isContentType({
                  id: field.id,
                  category: field.category || category,
                })
              "
              :field="field"
              :key="
                field.id && configTemplate
                  ? getFieldId({
                      id: field.id,
                      category: field.category || category,
                    })
                  : key
              "
              :bulkDelete="bulkDelete"
              :parentField="parentField"
              :category="field.category || category"
            />
          </template>
        </template>
        <div
          v-if="
            isObjectType({
              id: field.id,
              category: field.category || category,
            })
          "
          :key="
            field.id && configTemplate
              ? getFieldId({
                  id: field.id,
                  category: field.category || category,
                })
              : key
          "
        >
          <p
            class="object-label subtitle-2"
            v-if="
              bulkDelete ||
              (configVisibility['bulkEdit'] &&
                configVisibility['bulkEdit'][field.category || category] &&
                configVisibility['bulkEdit'][field.category || category][
                  field.id
                ])
            "
          >
            {{
              getFieldValue({
                value: "label",
                id: field.id,
                category: field.category || category,
              })
            }}
          </p>
          <fields
            class="object"
            :rows="field.layout"
            :category="field.category || category"
            :parentField="field.id"
            :id="field.id"
            :bulkDelete="bulkDelete"
          />
        </div>
      </template>
    </template>
  </div>
</template>

<script>
/**
 * @fileoverview Config fields
 *
 * @author Cameron Bulock <cameron.bulock@quavo.com>
 */

import { mapGetters } from "vuex";

import customFields from "./custom-fields";
import field from "./field";

import getFieldData from "@/util/getFieldData";

import fieldMap from "@/components/config-field/field-map.json";

export default {
  name: "ConfigFields",
  components: { field, customFields, fields: () => import("./fields") },
  props: {
    rows: {
      type: Array,
    },
    category: {
      type: String,
    },
    parentField: {
      type: String,
    },
    bulkDelete: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      mergedConfig: "getMergedConfig",
      configTemplate: "getConfigTemplate",
      configVisibility: "getConfigVisibility",
    }),
  },
  methods: {
    fieldList(category = this.category) {
      const fieldData = this.configTemplate && this.configTemplate[category];
      return fieldData && fieldData.AvailableFieldList;
    },
    getFieldData({ id, category }) {
      return getFieldData(this.fieldList(category), id);
    },
    getFieldId({ id, category }) {
      const fieldData = this.getFieldData({
        id,
        category,
      });
      return (fieldData && fieldData["FieldId"]) || "";
    },
    getFieldValue({ value, id, category }) {
      return (
        fieldMap[category] &&
        fieldMap[category][id] &&
        fieldMap[category][id][value]
      );
    },
    isObjectType({ id, category }) {
      // Need to special case this since it has a custom config component
      if (id === "UseBODenyReasonConfiguration") return false;
      const fieldData = this.getFieldData({
        id,
        category,
      });
      return fieldData && fieldData["Type"] === "object";
    },
    isContentType({ id, category }) {
      const fieldData = this.getFieldData({
        id,
        category,
      });
      return fieldData && fieldData["Type"] === "content";
    },
  },
};
</script>

<style lang="scss" scoped>
.fields {
  display: grid;
  &::v-deep {
    .field {
      border-bottom: 1px solid $qvo-color-grey-200;
    }
  }
}
.fields:not(.object) {
  &::v-deep {
    & > .field {
      &:last-child {
        border-bottom: none;
      }
    }
  }
}
.object-label {
  margin: $qvo-spacing-8 0 0 $qvo-spacing-8;
}
</style>